import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import InitialQuestions from './initial/questions';

const SybilQuestions = [...InitialQuestions];

const _type = SybilQuestions;
export type SybilHRTFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default SybilQuestions;
